import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (idVariant) {
  const routeLang = useRouteLang();

  try {
    return await $apiFetch(API_ENDPOINTS.ESHOP_PRODUCT_VARIANT_ID_TRANSLATION, {
      method: 'GET',
      path: { idVariant },
      params: {
        locale: routeLang.locale.value
      }
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}
